export const initialState = () => ({
  orderToAudit: "",
  orderToView: "",
  isViewOnly: true,
  isEditingData: false,
  isEditingFinishedOrder: false,
  currentStep: 1,
  loading: {
    show: false,
    message: ""
  },
  indexStepsAlreadyVisited: 1,
  currentSteps: [],

  order: {},
  originalCustomerAddress: null,

  client: {
    typeClient: "",
    cpf: "",
    rg: "",
    generalRegistrationExempt: false,
    fullName: "",
    email: "",
    birthDate: "",
    motherName: "",
    fatherName: "",
    gender: "",
    profession: "",
    maritalStatus: "",
    landline: "",
    landlineType: "",
    landlineParticularity: "",
    cellphone: "",
    anotherContact: null,
    isAnotherContactReturnedFilled: false,
    schooled: null,
    city: "",
    postcode: "",
    address: "",
    number: "",
    whatsappContact: "",
    secondaryAddress: {
      type: "",
      text: "",
      value: ""
    },
    condominiumComplement: {
      condominium_id: "",
      condominium_name: "",
      block: "",
      apartment: ""
    },
    neighborhood: "",
    state: "",

    cnpj: "",
    stateRegistration: "",
    exempt: false,
    corporateName: "",
    corporateType: "",
    companyState: 0,
    openingDate: "",
    legalRepresentative: "",
    legalRepresentativeCpf: ""
  },

  biometry: {
    documentFront: null,
    documentBack: null,
    documentFull: null,
    selfie: null,
    similarity: null,
    status: null,
    type_of_analysis: null,
    tries: null,
    uuid: null,
    hasData: null,

    approved: null,
    reproved: null,
    resent: null,
    note: "",
    image_format: "",
    image_document_type: "",
    sale: null,
  },

  products: [],

  billing: {
    dueDate: "",
    shipping: "",
    clientType: "",
    contractType: "",
    contractModel: "",
    payment: "",
    bank: "",
    bankName: "",
    agency: "",
    account: "",
    whatsapp: "",

    isSameAddress: 1,
    address: "",
    postcode: "",
    city: "",
    cityId: "",
    complements: [],
    neighborhood: "",
    number: "",
    noNumber: true,
    state: ""
  },

  contract: {
    sale_origin: "",
    wallet: "",
    contract_type: ""
  },

  coverage: {
    uuid: null,
    status: null,
    date: null
  },

  credit: {
    uuid: null,
    status: null,
    date: null
  },

  installation: {
    period: "",
    date: ""
  },

  showPrintOrder: false,

  optionsStatusReasons: [],

  optionsServicesStatus: [],
  isRouteReady: false,
  coverageDetail: null,

  productBillingDiscount: 0,
  hasChangeShippingMethod: false,
  hasChangePaymentMethod: false,

  commission: null,

  auditFlow: {},
})
